// Migrated to Polaris Web Components
import React, { use, useEffect, useState } from 'react';
import { FormatTimeDuration } from '../common/FormatTimeDuration';
import { deleteTemplateById, getShopUrl, getTemplateByPagination } from '../Services/CommonServices';
import CSVMapping from '../Pages/CSVMapping';
import DeleteModal from './DeleteModal';

export default function Presets({ connectionType, template, refreshKey, action, onComplete, activate, setActivate }) {
    console.log("template in presets", connectionType, template, refreshKey, action, onComplete);
    const [presets, setPresets] = React.useState([]);
    const [pageNo, setPageNo] = React.useState(1);
    const [pageSize, setPageSize] = React.useState(10);
    const [presetLoading, setPresetLoading] = React.useState(false);
    const [selectedTab, setSelectedTab] = useState(0);
    const [selectedType, setSelectedType] = useState("File");
    const [openMapModal, setOpenMapModal] = useState(false);
    const [csvHeaders, setCsvHeaders] = useState([]);
    const [incomingShopifyHeaders, setIncomingShopifyHeaders] = useState([]);
    const [selectedTemplate, setSelectedTemplate] = useState(null);
    const [deleteModalActive, setDeleteModalActive] = useState(false);
    const [selectedPreset, setSelectedPreset] = useState(null);
    const handleTabChange = (selectedIndex) => {
        setPageNo(1);
        setPageSize(10);
        const selectedTabData = tabs[selectedIndex];
        setSelectedTab(selectedIndex);
        var selectedType = selectedTabData.content.toLowerCase() === "product" ? "File" : selectedTabData.content;
        setSelectedType(selectedType);
        GetPresets(selectedType);
    };
    const resourceName = {
        singular: 'preset',
        plural: 'presets'
    };
    const [itemStrings, setItemStrings] = useState([
        'Product',
        // 'XML',
        // 'Sheets',
        // 'FTP'
    ]);

    const openDeleteModal = (presetId) => {
        setDeleteModalActive(true);
        setSelectedPreset(presetId);
    };
    
    const cancelUpload = () => {
        GetPresets(connectionType);
        setOpenMapModal(false);
        setCsvHeaders([]);
        setIncomingShopifyHeaders([]);
        setSelectedTemplate(null);
    }

    const uploadError = (type) => {
        setOpenMapModal(false);
        setCsvHeaders([]);
        setIncomingShopifyHeaders([]);
        setSelectedTemplate(null);
    };
    
    const submitUpload = () => {
        setOpenMapModal(false);
        setCsvHeaders([]);
        setIncomingShopifyHeaders([]);
        setSelectedTemplate(null);
        GetPresets(connectionType); // Refresh presets after submit
    }
    const tabs = itemStrings.map((item, index) => ({
        content: item,
        index,
        onAction: () => { },
        id: `${item}-${index}`,
        isLocked: index === 0,

    }));
    var storeUrl = getShopUrl();
    useEffect(() => {
        if (connectionType) { GetPresets(connectionType); setSelectedType(connectionType); }
    }, []);

    useEffect(() => {
        // Handle modal visibility based on activate prop
        const modal = document.getElementById('presets-modal');
        if (modal) {
            if (activate && modal.showOverlay) {
                modal.showOverlay();
            } else if (!activate && modal.hideOverlay) {
                modal.hideOverlay();
            }
        }
    }, [activate]);

    useEffect(() => {
        // handleEdit(template);
        if (template) {
            handleEdit(template.id, template.template);
            setSelectedType(connectionType);
        }
    }, [template, refreshKey]);

    useEffect(() => {
        GetPresets(selectedType);
    }, [pageNo, pageSize]);

    const GetPresets = async (type) => {
        try {
            setPresetLoading(true);
            const response = await getTemplateByPagination(storeUrl, pageNo, pageSize, type);
            setPresets(Array.isArray(response) ? response : []);
        } catch (error) {
            console.error('Error fetching presets:', error);
            setPresets([]);
        } finally {
            setPresetLoading(false);
        }
    };
    const deletePreset = async (id) => {
        try {
            const response = await deleteTemplateById(storeUrl, id);
            if (response) {
                setPresets((prev) => prev.filter((preset) => preset.id !== id));
            }
        } catch (error) {
            console.error('Error deleting preset:', error);
        }
    };

    const handleEdit = (id, templateJson) => {
        const parsedTemplate = JSON.parse(templateJson);
        const csvHeaderSet = new Set();
        const shopifyHeaderSet = new Set();
        parsedTemplate?.productMapping?.forEach(item => {
            if (item?.csvHeader) csvHeaderSet.add(item.csvHeader.trim());
            item?.shopifyHeaders?.forEach(sh => {
                if (sh?.header) shopifyHeaderSet.add(sh.header.trim());
            });
        });
        parsedTemplate?.tagsMapping?.forEach(tag => {
            if (tag?.mappedHeader) csvHeaderSet.add(tag.mappedHeader.trim());
        });
        parsedTemplate?.metafieldMapping?.forEach(meta => {
            if (meta?.csvHeaders) csvHeaderSet.add(meta.csvHeaders.trim());
        });
        const csvHeaders = Array.from(csvHeaderSet);
        const shopifyHeaders = Array.from(shopifyHeaderSet);
        setCsvHeaders(csvHeaders);
        setIncomingShopifyHeaders(shopifyHeaders);
        setOpenMapModal(true);
        setSelectedTemplate(id);
    };

    const handlePrevious = () => {
        if (pageNo > 1) {
            setPageNo(pageNo - 1);
        }
    };

    const handleNext = () => {
        setPageNo(pageNo + 1);
    };

    // Calculate pagination state
    const hasPrevious = pageNo > 1;
    const hasNext = presets?.length === pageSize; // If we got a full page, there might be more

    return (
        <>
            <s-modal id="presets-modal" size="small" heading="Presets" padding="none">
                    <s-stack gap="base">
                        
                        {openMapModal && (
                            <CSVMapping 
                                cancelUpload={cancelUpload} 
                                uploadError={uploadError} 
                                submitUpload={submitUpload} 
                                csvHeaders={csvHeaders} 
                                incomingShopifyHeaders={incomingShopifyHeaders} 
                                activate={openMapModal} 
                                file={null} 
                                storeUrl={storeUrl} 
                                dbTagSeparator={""} 
                                currentRoute={"preset"} 
                                uploadType={selectedType} 
                                ftpConfig={null} 
                                templateEditId={selectedTemplate} 
                                onComplete={onComplete}
                                setCompletedSteps={() => {}} 
                                setSelectedTemplateId={() => {}}
                            />
                        )}
                        
                        <s-table
                            loading={presetLoading}
                            paginate={true}
                            hasPreviousPage={hasPrevious}
                            hasNextPage={hasNext}
                            onPreviousPage={handlePrevious}
                            onNextPage={handleNext}
                        >
                            <s-table-header-row>
                                <s-table-header>ID</s-table-header>
                                <s-table-header>Preset Name</s-table-header>
                                <s-table-header>Actions</s-table-header>
                            </s-table-header-row>
                            <s-table-body>
                                {
                                // presetLoading ? (
                                //     <s-table-row>
                                //         <s-table-cell colSpan="3">
                                //             <s-box padding="extra-large">
                                //                 <s-stack direction="block" gap="large" alignment="center">
                                //                     <s-spinner size="large" />
                                //                     <s-text variant="bodyMd" as="p" tone="subdued">
                                //                         Loading presets...
                                //                     </s-text>
                                //                 </s-stack>
                                //             </s-box>
                                //         </s-table-cell>
                                //     </s-table-row>
                                // ) :
                                 presets?.length === 0 ? (
                                    <s-table-row>
                                        <s-table-cell colSpan="3">
                                            <s-box padding="extra-large">
                                                <s-stack direction="block" gap="large" alignment="center">
                                                    <s-text variant="headingMd" as="h3" alignment="center">
                                                        No presets yet
                                                    </s-text>
                                                    <s-text variant="bodyMd" as="p" tone="subdued" alignment="center">
                                                        Start by creating a new preset to save your configurations.
                                                    </s-text>
                                                </s-stack>
                                            </s-box>
                                        </s-table-cell>
                                    </s-table-row>
                                ) : (
                                    presets?.map((preset, index) => {
                                        const { id, name, template } = preset;
                                        return (
                                            <s-table-row key={id}>
                                                <s-table-cell>
                                                    <s-text type="strong">{((pageNo - 1) * pageSize) + index + 1}</s-text>
                                                </s-table-cell>
                                                <s-table-cell>{name}</s-table-cell>
                                                <s-table-cell>
                                                    <s-button-group variant="segmented">
                                                        <s-button 
                                                            slot="secondary-actions"
                                                            onClick={() => handleEdit(id, template)} 
                                                            icon="edit" 
                                                            tone='success'
                                                        />
                                                        <s-button 
                                                            slot="secondary-actions"
                                                            onClick={() => openDeleteModal(preset)} 
                                                            icon="delete" 
                                                            tone='critical'
                                                        />
                                                    </s-button-group>
                                                </s-table-cell>
                                            </s-table-row>
                                        );
                                    })
                                )}
                            </s-table-body>
                        </s-table>
                    </s-stack>
            </s-modal>
            
            {deleteModalActive && selectedPreset && (
                <DeleteModal
                    active={deleteModalActive}
                    setActive={(v) => { setDeleteModalActive(v); if (!v) setSelectedPreset(null); }}
                    handleDelete={() => deletePreset(selectedPreset.id)}
                    itemName={selectedPreset?.name}
                />
            )}
        </>
    );
}